module.exports = __webpack_public_path__ + "details1.4d73b920.jpg";